import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import { Settings, Users, Mail } from "feather-icons-react";

export function Management() {
  const navigate = useNavigate();

  return (
    <div className={styles.management}>
      <div className={styles.header}>
        <h1>Management Center</h1>
        <p>Manage your application settings and content</p>
      </div>

      <div className={styles.cards}>
        <div className={styles.card} onClick={() => navigate("/admin/management/quick-links")}>
          <div className={styles.cardIcon}>
            <Settings size={32} />
          </div>
          <div className={styles.cardContent}>
            <h3>Quick Links Manager</h3>
            <p>Manage the quick links displayed on the client dashboard</p>
            <span className={styles.cardArrow}>→</span>
          </div>
        </div>

        <div className={styles.card} onClick={() => navigate("/admin/management/contacts")}>
          <div className={styles.cardIcon}>
            <Mail size={32} />
          </div>
          <div className={styles.cardContent}>
            <h3>Contacts Manager</h3>
            <p>Manage contact information displayed to clients</p>
            <span className={styles.cardArrow}>→</span>
          </div>
        </div>
      </div>
    </div>
  );
}
